<template>
  <div class="editor">
    <i class="el-icon-view preview-button" @click="preview = !preview"></i>
    <VueEditor
      v-model="eContent"
      useCustomImageHandler
      @imageAdded="handleImageAdded"
    ></VueEditor>
    <el-dialog custom-class="dialog-preview" top="5vh" :visible.sync="preview">
      <TextEditorPreview :content="eContent"></TextEditorPreview>
    </el-dialog>
  </div>
</template>

<script>
import { OopsErrorELMessage } from "@/mixins";
import { VueEditor } from "vue2-editor";
import TextEditorPreview from "@/components/TextEditorPreview";
export default {
  name: "TextEditor",
  props: ["content"],
  mixins: [OopsErrorELMessage],
  components: {
    VueEditor,
    TextEditorPreview
  },
  data() {
    return {
      eContent: "",
      preview: false
    };
  },
  watch: {
    content(val) {
      this.eContent = val;
    },
    eContent(val) {
      this.$emit("update:content", val);
    }
  },
  methods: {
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      let formData = new FormData();
      formData.append("image", file);

      this.$http({
        url: "/api/v1/images",
        method: "POST",
        data: formData
      })
        .then(result => {
          let url = result.data.url; // Get url from response
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch(err => {
          this.oopsError(err);
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles-variables.scss";
/deep/.ql-toolbar {
  position: sticky;
  position: -webkit-sticky;
  top: $nav-height;
  background-color: white;
  z-index: 100;
}
/deep/.ql-editing {
  margin-left: $sidebar-width;
}
.editor {
  position: relative;
}
.preview-button {
  position: absolute;
  top: -18px;
  right: 3px;
  color: #68b4ff;
  cursor: pointer;
}
/deep/.dialog-preview {
  width: auto;
  max-width: 1060px;
  min-width: 768px;
}
</style>
